import React, { createContext, useContext, useState, useRef } from 'react';
import { Toast } from 'primereact/toast';
import { toastsSuppressed, SUBSCRIPTION_402_MESSAGE, FEATURE_402_MESSAGE } from '../../utils/planState';

const ToastContext = createContext();

export function useCustomToast () {
    return useContext(ToastContext);
}

export const GlobalToastProvider = ({ children }) => {
    const toastRef = useRef(null);

    const showToast = (severity, summary, detail,content = null) => {
        // The no-package state replaces every page and explains itself; neither it
        // nor the subscription 402 that put the user there may also toast.
        if (detail === SUBSCRIPTION_402_MESSAGE) return;
        // The package lacks a feature: an error toast for it is noise (the page shows a
        // calm card instead). Only error toasts - the amber upgrade toast of a clicked
        // action (onUpgrade402) is a different severity and is kept.
        if (severity === 'error' && detail === FEATURE_402_MESSAGE) return;
        if (toastsSuppressed() && severity !== 'success') return;
        if (content == null)
            toastRef.current.show({ severity: severity, summary: summary, detail: detail, life: 3000 });
        else
            toastRef.current.show({ severity: severity, summary: summary, detail: detail, content: content, sticky: 5000 });
    };
 
    return (
        <ToastContext.Provider value={ { showToast } }>
            <Toast ref={ toastRef } position="bottom-center"></Toast>
            { children }
        </ToastContext.Provider>
    );
}

